import { useEffect, useState } from "react";
import axios from "axios";
import { Clock, MapPin, CalendarDays } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { IMAGES } from "../data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fmt = (iso) => {
  if (!iso) return { m: "TBD", d: "", y: "" };
  const dt = new Date(iso + "T00:00:00");
  if (isNaN(dt)) return { m: "TBD", d: "", y: "" };
  return {
    m: dt.toLocaleString("en-US", { month: "short" }).toUpperCase(),
    d: dt.getDate(),
    y: dt.getFullYear(),
  };
};

const TYPE_COLORS = {
  Service: "text-secondary",
  "ALU Class": "text-primary",
  "Regional Gathering": "text-secondary",
  Conference: "text-primary",
};

export default function Events() {
  const [events, setEvents] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios.get(`${API}/public/events`)
      .then((r) => setEvents(r.data))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  return (
    <div data-testid="events-page">
      <PageHeader
        overline="Gather · Grow · Ascend"
        lines={["Events"]}
        sub="Services, ALU class dates, and regional gatherings across the Network."
        image={IMAGES.worship2}
      />

      <section className="px-6 md:px-10 max-w-[1600px] mx-auto pb-32">
        {loaded && events.length === 0 && (
          <Reveal>
            <div className="border border-border p-16 text-center">
              <CalendarDays className="text-secondary mx-auto mb-6" size={40} />
              <p className="font-editorial italic text-2xl text-muted-foreground">
                No events on the calendar yet — check back soon.
              </p>
            </div>
          </Reveal>
        )}

        <div className="border-t border-border">
          {events.map((e, i) => {
            const d = fmt(e.date);
            return (
              <Reveal key={e.id} delay={(i % 6) * 0.05}>
                <div
                  className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-8 border-b border-border items-center hover:bg-muted/20 transition-colors duration-300"
                  data-testid="event-row"
                >
                  <div className="md:col-span-2 flex md:flex-col items-baseline md:items-start gap-3 md:gap-0">
                    <span className="font-display text-5xl text-secondary leading-none">{d.d}</span>
                    <span className="overline text-foreground text-[0.7rem]">{d.m} {d.y}</span>
                  </div>
                  <div className="md:col-span-7">
                    <span className={`overline text-[0.6rem] ${TYPE_COLORS[e.type] || "text-muted-foreground"}`}>{e.type}</span>
                    <h3 className="font-display uppercase text-2xl md:text-4xl text-foreground mt-1 group-hover:text-secondary transition-colors duration-300">
                      {e.title}
                    </h3>
                    {e.description && <p className="font-body text-muted-foreground mt-2 max-w-xl">{e.description}</p>}
                  </div>
                  <div className="md:col-span-3 space-y-2">
                    {e.time && <p className="font-body text-sm text-foreground flex items-center gap-2"><Clock size={14} className="text-secondary" />{e.time}</p>}
                    {e.location && <p className="font-body text-sm text-muted-foreground flex items-center gap-2"><MapPin size={14} className="text-secondary" />{e.location}</p>}
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>
    </div>
  );
}
